module.exports = __webpack_public_path__ + "img/amazon.c4d83b7b.png";